import { render, staticRenderFns } from "./OrderDeliver.vue?vue&type=template&id=420ada3f&scoped=true&"
import script from "./OrderDeliver.vue?vue&type=script&lang=js&"
export * from "./OrderDeliver.vue?vue&type=script&lang=js&"
import style0 from "./OrderDeliver.vue?vue&type=style&index=0&id=420ada3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420ada3f",
  null
  
)

export default component.exports